/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GroupDefs from './defs.defs.js'

const $nsid = 'chat.bsky.group.getJoinLinkPreviews'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  codes: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), {
    minLength: 1,
    maxLength: 50,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  joinLinkPreviews: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<GroupDefs.JoinLinkPreviewView>(
          (() => GroupDefs.joinLinkPreviewView) as any,
        ),
        /*#__PURE__*/ l.typedRef<GroupDefs.DisabledJoinLinkPreviewView>(
          (() => GroupDefs.disabledJoinLinkPreviewView) as any,
        ),
        /*#__PURE__*/ l.typedRef<GroupDefs.InvalidJoinLinkPreviewView>(
          (() => GroupDefs.invalidJoinLinkPreviewView) as any,
        ),
      ],
      false,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get public information about groups from join links. The output array matches the input codes one-to-one by position (and each view also carries its 'code'). Disabled codes return a disabledJoinLinkPreviewView, and codes that do not map to a previewable link return an invalidJoinLinkPreviewView. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
